if (!customElements.get('category-showcase-slider')) {
  class CategoryShowcaseSlider extends HTMLElement {
    constructor() {
      super();

      this.mql = window.matchMedia('(max-width: 768px)');
      this.instance = null;

      this.onMediaChange = this.apply.bind(this);
      this.onSectionLoad = this.handleSectionLoad.bind(this);

      if (this.mql.addEventListener) {
        this.mql.addEventListener('change', this.onMediaChange);
      } else if (this.mql.addListener) {
        this.mql.addListener(this.onMediaChange);
      }

      document.addEventListener('shopify:section:load', this.onSectionLoad);
    }

    connectedCallback() {
      this.apply();
    }

    disconnectedCallback() {
      this.destroy();

      if (this.mql.removeEventListener) {
        this.mql.removeEventListener('change', this.onMediaChange);
      } else if (this.mql.removeListener) {
        this.mql.removeListener(this.onMediaChange);
      }

      document.removeEventListener('shopify:section:load', this.onSectionLoad);
    }

    handleSectionLoad(event) {
      if (event.target && event.target.contains(this)) {
        this.destroy();
        this.apply();
      }
    }

    getViewport() {
      return this.querySelector('[data-category-showcase-slider]');
    }

    getProgressEl() {
      return this.querySelector('.section-category-showcase__progress');
    }

    build() {
      if (this.instance || !window.Swiper) {
        return;
      }

      const viewport = this.getViewport();
      if (!viewport) {
        return;
      }

      viewport.classList.add('swiper');

      const progressEl = this.getProgressEl();
      const useProgress =
        viewport.getAttribute('data-progress') === 'true' && progressEl;

      this.instance = new window.Swiper(viewport, {
        slidesPerView: parseFloat(viewport.getAttribute('data-spv')) || 1.15,
        spaceBetween: 0,
        watchOverflow: true,
        grabCursor: true,
        scrollbar: useProgress ? { el: progressEl, draggable: true } : false
      });
    }

    destroy() {
      if (this.instance) {
        this.instance.destroy(true, true);
        this.instance = null;
      }

      const viewport = this.getViewport();
      if (viewport) {
        viewport.classList.remove('swiper');
      }
    }

    apply() {
      if (this.mql.matches) {
        this.build();
      } else {
        this.destroy();
      }
    }
  }

  customElements.define('category-showcase-slider', CategoryShowcaseSlider);
}
